/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ValidationInputs */

const en_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation`)
};

const ar_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحقق`)
};

const bn_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভ্যালিডেশন`)
};

const de_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validierung`)
};

const es_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validación`)
};

const fr_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation`)
};

const pt_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validação`)
};

const zh_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证`)
};

const tr_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğrulama`)
};

const ru_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка`)
};

const pl_svchip_validation = /** @type {(inputs: Svchip_ValidationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walidacja`)
};

/**
* | output |
* | --- |
* | "Validation" |
*
* @param {Svchip_ValidationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_validation = /** @type {((inputs?: Svchip_ValidationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ValidationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_validation(inputs)
	if (locale === "bn") return bn_svchip_validation(inputs)
	if (locale === "de") return de_svchip_validation(inputs)
	if (locale === "es") return es_svchip_validation(inputs)
	if (locale === "fr") return fr_svchip_validation(inputs)
	if (locale === "pt") return pt_svchip_validation(inputs)
	if (locale === "zh") return zh_svchip_validation(inputs)
	if (locale === "tr") return tr_svchip_validation(inputs)
	if (locale === "ru") return ru_svchip_validation(inputs)
	if (locale === "pl") return pl_svchip_validation(inputs)
	return en_svchip_validation(inputs)
});